import { Injectable } from '@angular/core';
import * as $ from 'jquery';

@Injectable()
export class UnsavedChangesDialogService {

  constructor() { }

  showDialog(): Promise<boolean> {
    var promise = new Promise<boolean>((resolve, reject) => {
      $('#unsavedChangesModal').modal('show');
      var discardButton = $('#unsavedChangesDiscard');
      var stayButton = $('#unsavedChangesModal .unsavedChangesStay');
      discardButton.click(() => {
        resolve(true);
      });
      stayButton.click(() => {
        resolve(false);
      });
    });
    return promise;
  }

  showDialogWithSaveButton(showSaveButton: boolean = false): Promise<'stay' | 'discard' | 'save'> {
    if(showSaveButton)
    {
      $('#saveChangesAndContinue').show();
    }
    
    return new Promise(resolve => {
      $('#unsavedChangesModal').modal('show');

      const discardButton = $('#unsavedChangesDiscard');
      const stayButtons = $('#unsavedChangesModal .unsavedChangesStay');
      const saveButton = $('#saveChangesAndContinue');

      // Remove previous handlers (important if popup opens multiple times)
      discardButton.off('click');
      stayButtons.off('click');
      saveButton.off('click');

      discardButton.on('click', () => resolve('discard'));
      stayButtons.on('click', () => resolve('stay'));
      saveButton.on('click', () => resolve('save'));
    });
  }

}
